import Colors from 'common/constants/colors';

const colorsName = [
  'blue',
  'green',
  'orange',
  'purple',
  'red',
  'teal',
  'yellow',
];
export const LinkDefaultColor = Colors.gray300;
export default colorsName.map((color) => ({
  node: Colors[`${color}300`],
  link: Colors[`${color}100`],
}));
